import { InjectionToken } from '@angular/core';

export interface DialogContext {
  close: () => void;
}

export const DIALOG_CONTEXT = new InjectionToken<DialogContext>(
  'DIALOG_CONTEXT',
);
